module.exports = __webpack_public_path__ + "static/media/KegMeisters-web-logo.13ca4a46.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/KegMeisters-web-logo.png
// module id = 1173
// module chunks = 0